module.exports = __webpack_public_path__ + "media/waiting-room-notification.44f44ca8.mp3";